module.exports = __webpack_public_path__ + "img/tztb.fd29608a.svg";